import { z } from 'zod'
import { OneMB } from '@/core/constants/sizes.ts'
import { Extension } from '@/core/types/AppConfig.ts'

const editableFileSchema = z.union([z.string(), z.instanceof(FileList)])

export const fileSchema = (
  fileFormats: Extension[],
  maxSizeInMb: number,
  required?: boolean
) =>
  (required ? editableFileSchema : editableFileSchema.optional())
    .refine(
      (value) => {
        if (value instanceof FileList && required) {
          return value.length !== 0
        } else return true
      },
      { message: 'Requerido' }
    )
    .refine(
      (value) => {
        if (value instanceof FileList) {
          return value.length > 0
            ? fileFormats.map((ext) => ext as String).includes(value[0].type)
            : true
        } else return true
      },
      {
        message: `El fichero debe ser ${fileFormats
          .map((s) => s.split('/')[1].toUpperCase())
          .join(', ')}`
      }
    )
    .refine(
      (value) => {
        if (value instanceof FileList) {
          return value.length > 0 ? value[0].size < maxSizeInMb * OneMB : true
        } else return true
      },
      {
        message: `El fichero debe ser menor a ${maxSizeInMb}Mb`
      }
    )
